import { FC } from 'react';
import { DAYS_PER_WEEK, MONTHS_PER_YEAR } from '@/utils/activity-calendar/constants';

const MONTH_SKELETON_WEEKS = 5;
const YEAR_MONTH_SKELETON_CELLS = 35;
const PRIMARY_SKELETON_CARD_INTERVAL = 3;
const SECONDARY_SKELETON_CARD_INTERVAL = 5;

const S: FC<{ className?: string }> = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 ${className ?? ''}`} />
);

export const WeekViewSkeleton: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  if (isMobile) {
    return (
      <div className="flex flex-col gap-[10px]">
        {Array.from({ length: DAYS_PER_WEEK }, (_, i) => (
          <div key={i} className="overflow-hidden rounded-[10px] border" style={{ borderColor: '#E5E7EB' }}>
            <div className="flex items-center gap-[8px] border-b px-[12px] py-[8px]" style={{ borderColor: '#E5E7EB' }}>
              <S className="h-[10px] w-[26px]" />
              <S className="h-[18px] w-[14px]" />
            </div>
            <div className="flex flex-col gap-[7px] p-[10px]">
              {i % PRIMARY_SKELETON_CARD_INTERVAL === 0 ? (
                <S className="h-[60px] rounded-[7px]" />
              ) : (
                <S className="mx-auto h-[10px] w-[20px]" />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto pb-[2px]">
      <div
        className="grid min-w-min gap-[10px]"
        style={{ gridTemplateColumns: `repeat(${DAYS_PER_WEEK}, minmax(118px, 1fr))` }}
      >
        {Array.from({ length: DAYS_PER_WEEK }, (_, i) => (
          <div
            key={i}
            className="flex min-w-0 flex-col overflow-hidden rounded-[10px] border bg-white"
            style={{ borderColor: '#E5E7EB' }}
          >
            <div className="border-b px-[6px] py-[8px] text-center" style={{ borderColor: '#E5E7EB' }}>
              <S className="mx-auto mb-[4px] h-[10px] w-[24px]" />
              <S className="mx-auto h-[18px] w-[18px] rounded-full" />
            </div>
            <div className="flex min-h-[200px] flex-col gap-[7px] p-[7px]">
              {i % PRIMARY_SKELETON_CARD_INTERVAL === 0 && <S className="h-[60px] rounded-[7px]" />}
              {i % SECONDARY_SKELETON_CARD_INTERVAL === 0 && <S className="h-[60px] rounded-[7px]" />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MonthViewSkeleton: FC = () => (
  <div>
    <div className="mb-[8px] grid grid-cols-7 gap-[8px]">
      {Array.from({ length: DAYS_PER_WEEK }, (_, i) => (
        <S key={i} className="h-[13px]" />
      ))}
    </div>
    <div className="flex flex-col gap-[8px]">
      {Array.from({ length: MONTH_SKELETON_WEEKS }, (_, w) => (
        <div key={w} className="grid grid-cols-7 gap-[8px]">
          {Array.from({ length: DAYS_PER_WEEK }, (_, d) => (
            <S key={d} className="min-h-[94px] rounded-[10px]" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const YearViewSkeleton: FC = () => (
  <div className="grid grid-cols-2 gap-[14px] min-[700px]:grid-cols-3 min-[1000px]:grid-cols-4">
    {Array.from({ length: MONTHS_PER_YEAR }, (_, i) => (
      <div
        key={i}
        className="flex flex-col gap-[9px] rounded-[10px] border bg-white px-[12px] pb-[11px] pt-[12px]"
        style={{ borderColor: '#E5E7EB' }}
      >
        <S className="h-[15px] w-[72px]" />
        <div className="grid grid-cols-7 gap-[2px]">
          {Array.from({ length: YEAR_MONTH_SKELETON_CELLS }, (_, j) => (
            <S key={j} className="h-[15px] rounded-[3px]" />
          ))}
        </div>
      </div>
    ))}
  </div>
);
